
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n    <header>\n        <h1>Please wait...</h1>\n    </header>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  